import { combineLatest, Observable, of, OperatorFunction } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Dictionary } from '@ngrx/entity';

export abstract class Enricher<T,E,O> {

    enrichments$: Observable<O>;

    abstract doEnrich(T, O): E;

    enrichOne(): OperatorFunction<T, E> {
      return (source: Observable<T>) => source.pipe(
        switchMap(item => {
          return combineLatest([of(item), this.enrichments$]).pipe(
            map(([observedItem, enrichments]) => {
              return this.doEnrich(observedItem, enrichments);
            })
          )
        })
      );
    }

    enrichArray(): OperatorFunction<T[], E[]> {
      return (source: Observable<T[]>) => source.pipe(
        switchMap(
          items => combineLatest([of(items), this.enrichments$]).pipe(
            map(
              ([observedItems, enrichments]) => observedItems.map(item => this.doEnrich(item, enrichments))
            )
          )
        )
      );
    }

    enrichDictionary(): OperatorFunction<Dictionary<T>, Dictionary<E>> {
      return (source: Observable<Dictionary<T>>) => source.pipe(
        switchMap(
          items => combineLatest([of(items), this.enrichments$]).pipe(
            map(
              ([observedItems, enrichments]) => {
                const enriched: Dictionary<E> = {};
                for (const i in observedItems) {
                  enriched[i] = this.doEnrich(observedItems[i], enrichments);
                }
                return enriched;
              }
            )
          )
        )
      );
    }
  }
